import React, { useEffect, useState } from "react";
import { IoChevronBackCircleOutline } from "react-icons/io5";
import DataTable from "react-data-table-component";
import Loaders from "../../../assets/loaders/loaders";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiSearchAlt } from "react-icons/bi";
// import { PiFileCsvDuotone } from "react-icons/pi";
import WindowHead from "../../layouts/windowHead";
import Sidebar from "../../layouts/sidebar";
import { useLocation, useNavigate } from "react-router-dom";


export default function ViewMoreCampaign() {
    const [showNav, setShowNav] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    // eslint-disable-next-line
    const [items, setItems] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);


    useEffect(() => {
        const viewId = location.state?.viewId;

        fetchData(viewId, 1, search);
    }, [search, location.state?.viewId])

    const fetchData = async (campId, page, search) => {
        setIsLoading(true);
        fetch(`${process.env.REACT_APP_API_BASE_URL}/get_short_url_data/${campId}?pageNumber=${page}&search=${search}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: localStorage.getItem("tokenn")
                }
            }
        )
            .then((res) => res.json())
            .then(
                (result) => {
                    setIsLoading(false);
                    setItems(result?.data?.rows);
                    setFilter(result?.data?.rows);
                    setTotalRows(result.data.totalItems);
                },
                (error) => {
                    setIsLoading(false);
                    toast.error(error.message);
                }
            )
    }

    const columns = [
        {
            name: 'S. No.',
            selector: (_, index) => (currentPage - 1) * 20 + index + 1,
            width: '80px',
        },
        {
            name: 'Unique URL',
            selector: (row) => row.unique_url,
            width: '280px',
        },
        {
            name: 'E-mail / Contact No.',
            selector: (row) => row.user || '-',
            width: '250px',
        },
        {
            name: 'Click Count',
            selector: (row) => row.counts || '-',
            width: '150px',
            sortable: true
        },
        {
            name: 'Device',
            selector: (row) => row.userDevice || '-',
            width: '150px',

        },
        {
            name: 'Location',
            selector: (row) => row.userLocation || '-',
            width: '200px',

        },
        {
            name: 'IP',
            selector: (row) => row.userIp || '-',
            width: '150px',
        }
    ]

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, '', '');
    }

    // const handlePerRowsChange = async (rowperpage, page) => {
    //     fetchData(page, "")
    // };

    // const downloadFile = () => {
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = `${process.env.REACT_APP_API_BASE_URL}/download-campign-url-user-details/${location.state?.viewId}`
    //     downloadLink.download = 'Campaign-Details.csv'; // Provide the desired filename for download
    //     downloadLink.click();
    // }

    return (
        <>
            {isLoading && <Loaders />}
            <ToastContainer />


            <div className="bg-inner">
                <Sidebar show={showNav} onClose={() => setShowNav(false)} />
                <div className="d-flex flex-column ms-0 ms-xxl-3 col-12 col-sm-12 col-xxl-9">
                    <WindowHead sidebarOpen={() => setShowNav(!showNav)} />

                    <div className="main-content">

                        <div className="d-flex for-border">
                            <span>
                                <h4>URL Name: {location.state?.name}</h4>
                                <p>The above URL's Details are listed here.</p>
                            </span>
                            <button onClick={() => navigate('/manageUrl')} className="ms-auto icon-btn">
                                <IoChevronBackCircleOutline className="icon-grey" />
                            </button>
                        </div>

                        <div className="uploaded_items">

                            {/* <div className="my-2 m-md-0 d-flex">
                                <button onClick={() => downloadFile()} className="dnld-btn ms-auto">
                                    <PiFileCsvDuotone className="icon-grey" /> Export Data
                                </button>
                            </div> */}

                            <DataTable
                                // customStyles={tableHeaderStyle}
                                className="custom_tborder"
                                columns={columns}
                                data={filter}

                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                onChangePage={handlePageChange}
                                paginationPerPage={20}
                                paginationRowsPerPageOptions={[20]}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                paginationComponentOptions={''} // Pass the custom options here

                                fixedHeader
                                fixedHeaderScrollHeight="540px"
                                selectableRowsHighlight
                                highlightOnHover

                                subHeader
                                subHeaderComponent={
                                    <div className="d-flex w-75">
                                        <span className="d-flex w-50 me-2">
                                            <label htmlFor="gsearch" className="srch-btn"><BiSearchAlt /></label>
                                            <input type="search" className="form-control srch-fld" id="gsearch" placeholder='Search by Short URL/Contact No./Email'
                                                onChange={(e) => e.target.value}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setSearch(e.target.value);
                                                    }
                                                }} />
                                        </span>
                                    </div>
                                }
                                subHeaderAlign="left"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}
